<template>
  <div class="sign-in-wrapper">
    <!-- <div class="back-btn-container" @click="goToMain()">
      <img src="../../public/custom/images/back-arrow.svg" alt="Back arrow" class="back-img">
      <span class="back-btn-text">{{ $t('message.passwordRecovery.backBtn') }}</span>
    </div> -->
    <div class="sing-in-container">
      <div class="sign-in-block form-block" @keyup.enter="signIn()">
        <img @click="goToMain()" class="logo" src="../../public/custom/images/logo.svg" alt="Logo image">
        <div class="title">{{ $t('message.signIn.title') }}</div>
        <div class="login-wrapper" :class="{'invalid': errors.has('msisdn')}">
          <input type="text"
            class="login-input"
            :placeholder="$t('message.signIn.loginPlaceholder')"
            @maska="login = '375' + $event.target.dataset.maskRawValue"
            name="msisdn"
            v-validate="'msisdn'"
            v-maska="'+375 (##) ###-##-##'"
          >
        </div>
        <div class="login-error-block">{{ errors.first('msisdn') }}</div>
        <div class="password-wrapper" :class="{'invalid': errors.has('password')}">
          <input class="password-input"
            type="text"
            :placeholder="$t('message.signIn.passwordPlaceholder')"
            :class="{'password-visible': isShowPassword}"
            v-model="password"
            v-validate="'password'"
            name="password"
          >
          <img 
            @click.stop="showPasswordToggle()"
            class="eye" :src="require(`../../public/custom/images/eye-${isShowPassword ? 'on' : 'off'}.svg`)" 
            alt="Eye image"
          >
        </div>
        <div class="password-error-block">{{ errors.first('password') }}</div>
        <div class="otp-wrapper">
          <input type="text"
            :class="{'invalid': errors.has('otp')}"
            class="otp-input"
            :placeholder="$t('message.signIn.otpPlaceholder')"
            v-model="otp"
            name="otp"
            v-validate="'otp'"
          >
          <div class="send-otp-block" @click="getOtpCode()" :class="{'send-otp-disabled': isSendOtpCodeDisabled}">{{ $t('message.signIn.sendCode') }}</div>
        </div>
        <div class="otp-error-block">
          <div class="otp-error-text-block">{{ errors.first('otp') }}</div>
        </div>
        <div class="btn-block">
          <base-button
            :text="$t('message.signIn.signInBtn')"
            :disabled="isSignInBtnDisabled"
            :is-loading="isSignInBtnLoading"
            @click="signIn()"
          />
        </div>
        <div class="sign-up-block">
          <span @click="goToPasswordRecovery()" class="sign-up-link">{{ $t('message.signIn.forgotPassword') }}</span>
          <div class="border-block"></div>
          <span @click="$router.push({ name: 'msi' })" class="sign-up-link">{{ $t('message.signIn.msi') }}</span>
        </div>
        <div class="sign-up-block-mobile">
          <span @click="$router.push({ name: 'msi' })" class="sign-up-link-mobile">{{ $t('message.signIn.msi') }}</span>
          <span @click="goToPasswordRecovery()" class="sign-up-link-mobile">{{ $t('message.signIn.forgotPassword') }}</span>
        </div>
      </div>
      <div class="sign-in-block img-block"></div>
    </div>
  </div>
</template>

<script>
import BaseButton from '../components/base/BaseButton.vue';
export default {
  name: 'SignIn',
  inject: ['$httpService'],
  components: {
    BaseButton
  },
  data() {
    return {
      login: '',
      password: '',
      otp: '',
      isShowPassword: false,
      isSignInBtnLoading: false
    }
  },
  created() {
    const isAuthorizated = !!localStorage.getItem('token');

    if (isAuthorizated) {
      this.$router.push({ name: 'profile' });
    }
  },
  methods: {
    showPasswordToggle() {
      this.isShowPassword = !this.isShowPassword;
    },
    async getOtpCode() {
      if (!this.isSendOtpCodeDisabled) {
        await this.$httpService.auth.getOtpCode(this.login);
        this.$toast({text: this.$t('message.signIn.otpToastMsg')});
      }
    },
    goToMsi() {
      const url = window.entityCabinetSettings.msiApi.url;

      window.location.href = url;
    },
    goToPasswordRecovery() {
      this.$router.push({ name: 'PasswordRecovery' });
    },
    async signIn() {
      if (!this.isSignInBtnDisabled) {
        await this.$store.dispatch('signIn', {login: this.login, password: this.password, otp: +this.otp});
      }
    },
    goToMain() {
      this.$router.push({ name: 'main' });
    }
  },
  computed: {
    isSignInBtnDisabled() {
      return this.isEmptyFields || this.isHasFieldsErrors
    },
    isHasFieldsErrors() {
      return this.errors.items.length > 0;
    },
    isEmptyFields() {
      return !this.login || !this.password || !this.otp;
    },
    isSendOtpCodeDisabled() {
      return this.login === '375' || this.errors.has('msisdn');
    }
  }
}
</script>

<style lang="scss" scoped>
  .sign-in-wrapper {
    @include base-page-wrapper;
    height: auto;
    padding: 69px 0;
    min-height: 100vh;
    box-sizing: border-box;
    justify-content: center;
    position: relative;
    background: var(--sign-in-wrapper-bgc);
  }

  .back-btn-container {
    position: absolute;
    top: 3%;
    left: 5%;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .back-img {
      margin-right: 4px;
      height: 18px;
      width: 18px;
  }

  .back-btn-text {
      font-weight: 400;
      font-size: 16px;
      line-height: 135%;
      color: white;
  }

  .sing-in-container {
    @include base-sign-in-container;

    background: var(--sign-in-container-bgc);
    box-shadow: var(--sign-in-container-box-shadow);
  }

  .sign-in-block {
    width: 50%;
    height: 100%;
  }

  .logo {
    width: 150px;
    height: 31px;
    margin-bottom: 10%;
    cursor: pointer;
  }

  .title {
    margin-bottom: 5%;
    font-family: 'Montserrat';
    font-weight: 700;
    font-size: 32px;
    line-height: 39px;
    color: var(--sign-in-title-color);
  }

  .img-block {
    background-image: url('../../public/custom/images/Frame.png');
    background-position: center;
    background-size: cover;
    border-radius: 0 20px 20px 0;
  }

  .form-block {
    padding: 80px 0 80px 80px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }

  .login-wrapper,
  .password-wrapper,
  .otp-wrapper {
    height: 41px;
    width: 70%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .login-wrapper,
  .password-wrapper {
    border-bottom: 2px solid var(--sign-in-input-wrapper-underline);
  }

  .login-error-block,
  .password-error-block,
  .otp-error-block {
    height: 40px;
    width: 70%;
    white-space: pre-line;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: var(--error-message-color);
  }

  .otp-error-block {
    margin-bottom: 20px;
  }

  .login-input,
  .password-input,
  .otp-input {
    height: calc(100% - 2px);
    width: 100%;
    border: none;
    outline: none;
    font-weight: 400;
    font-size: 20px;
    line-height: 130%;
    color: #333333;

    &:focus {
      border: none;
      outline: none;
    }
  }

  .otp-input {
    width: 45%;
    border-bottom: 2px solid var(--sign-in-input-wrapper-underline);

    &:focus {
      border-bottom: 2px solid var(--sign-in-input-wrapper-underline);
    }
  }

  .send-otp-block {
    height: calc(100% - 2px);
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    width: 45%;
    text-align: right;
    font-weight: 400;
    font-size: 20px;
    line-height: 130%;
    cursor: pointer;
    color: #7D7D7D;
  }

  .send-otp-disabled {
    opacity: 0.3;
  }

  .otp-error-text-block {
    width: 45%;
  }

  .password-input {
    width: 80%;
    font-family: 'Bullet';
  }

  .password-input::placeholder {
    font-family: 'Open Sans', sans-serif;
  }

  .password-visible {
    font-family: 'Open Sans', sans-serif;
  }

  .eye {
    height: 32px;
    width: 32px;
    cursor: pointer;
  }

  .invalid {
    border-bottom: 2px solid var(--sign-in-input-wrapper-error-underline);

    &:focus {
      border-bottom: 2px solid var(--sign-in-input-wrapper-error-underline);
    }
  }

  .btn-block {
    height: 65px;
    width: 70%;
    margin-bottom: 30px;
  }

  .sign-up-block {
    width: 70%;
    height: 26px;
    display: flex;
    justify-content: center;
    font-weight: 400;
    font-size: 20px;
    line-height: 130%;
    text-decoration-line: underline;
    color: var(--sign-up-block-color);
  }

  .sign-up-block-mobile {
    display: none;
    flex-direction: column;
    align-items: center;
  }


  .border-block {
    margin: 0 15px;
    border-right: 1px solid var(--sign-up-block-color);
  }

  .sign-up-link {
    cursor: pointer;
    color: var(--sign-up-block-color);
  }

  .sign-up-link-mobile {
    font-weight: 400;
    font-size: 16px;
    line-height: 135%;
    color: #878787;
    cursor: pointer;
    text-decoration: underline;
  }

  .sign-up-link-mobile:first-of-type {
    margin-bottom: 20px;
  }

  @media screen and (max-width: 1550px) {
    .sign-up-block {
      font-size: 17px;
    }

    .title {
      font-size: 27px;
    }
  }

  @media screen and (max-width: 1290px) {
    .login-wrapper,
    .password-wrapper,
    .otp-wrapper,
    .btn-block,
    .sign-up-block {
      width: 90%;
    }

    .form-block {
      padding: 50px 0 50px 50px;
    }

    .sing-in-container {
      height: 670px;
    }
  }

  @media screen and (max-width: 1020px) {
    .img-block {
      display: none;
    }

    .login-wrapper,
    .password-wrapper,
    .otp-wrapper,
    .btn-block,
    .sign-up-block {
      width: 100%;
    }

    .sign-in-block {
      width: 100%;
    }

    .form-block {
      padding: 5%;
    }
  }

  @media screen and (max-width: 600px) {
    .title,
    .logo {
      margin-bottom: 40px;
    }

    .form-block {
      padding-top: 10%;
    }

    .login-wrapper, 
    .password-wrapper,
    .otp-input {
      border: none;
      -webkit-box-shadow: 0px 2px 0px 0px #CDCDCD;
      -moz-box-shadow: 0px 2px 0px 0px #CDCDCD;
      box-shadow: 0px 2px 0px 0px #CDCDCD;
    }
  }

  @media screen and (max-width: 550px) {
    .sign-up-block {
      display: none;
    }

    .sign-up-block-mobile {
      display: flex;
    }
  }

  @media screen and (max-width: 450px) {
    .sign-up-block {
      justify-content: space-between;
    }

    .sign-up-link {
      font-size: 16px;
    }

    .btn-block {
      height: 60px;
    }

    .send-otp-block {
      font-size: 18px;
    }
  }

  @media screen and (max-width: 400px) {
    .sign-up-link {
      font-size: 14px;
    }

    .send-otp-block {
      font-size: 16px;
    }
  }
</style>